import { 
  IPendingAttendanceApiCall, 
  IRestApiService, 
  PendingAttendance, 
  TokenVerificationResponse 
} from "../types";

class PendingAttendanceApiCall implements IPendingAttendanceApiCall {
  private restApiService: IRestApiService;

  constructor(restApiService: IRestApiService) {
    this.restApiService = restApiService;
  }

  addPendingAttendance(pendingAttendance: PendingAttendance, studioId: string): Promise<PendingAttendance> {
    return this.restApiService.post('pendingAttendance/' + studioId, {
      pendingAttendance: pendingAttendance,
    });
  }

  verifyToken(token: string): Promise<TokenVerificationResponse> {
    return this.restApiService.post('pendingAttendance/validate/' + token);
  }

  generatePin(pendingAttendance: PendingAttendance, studioId: string): Promise<PendingAttendance> {
    return this.restApiService.put(`pendingAttendance/${studioId}/pin`, {
      pendingAttendance: pendingAttendance,
    });
  }
}

export default PendingAttendanceApiCall;